import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../../hooks/api';
import { useTelegram } from '../../../hooks/auth/useTelegram';
import './ShopLoading.css';

function ShopLoading() {
    const { param } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // استخراج پارامترها از query string
    let shop = searchParams.get('sId');
    let product = searchParams.get('pId') || searchParams.get('commodityId');

    const { ChatId } = useTelegram();

    const [status, setStatus] = useState('loading');
    const [errorMessage, setErrorMessage] = useState('');
    const [targetTelegramUrl, setTargetTelegramUrl] = useState('');

    useEffect(() => {
        const tg = window.Telegram?.WebApp;
        const directChatId = tg?.initDataUnsafe?.user?.id || tg?.initDataUnsafe?.chat?.id;

        // بررسی قطعی محیط تلگرام
        const inTelegram = Boolean(
            ChatId ||
            directChatId ||
            (tg && tg.platform && tg.platform !== 'unknown') ||
            (tg && tg.initData && tg.initData !== '') ||
            window.location.hash.includes('tgWebAppData') ||
            window.location.search.includes('tgWebAppPlatform')
        );

        const pathname = window.location.pathname.toLowerCase();
        const isStart = pathname === '/start';
        const isRoot = pathname === '/' || pathname === '' || pathname === '/app' || pathname === '/loading' || isStart;

        // =================================================================
        // حالت ۱: کاربر داخل محیط تلگرام است
        // =================================================================
        if (inTelegram) {
            // اگر مسیر start است، مستقیم و بدون چک کردن پارامترهای فروشگاه به صفحه اصلی برود
            if (isStart) {
                navigate('/HomePage', { replace: true });
                return;
            }

            // استخراج از start_param در صورتی که در query string نبود
            if (!shop && tg?.initDataUnsafe?.start_param) {
                const startParam = tg.initDataUnsafe.start_param;
                // اگر پارامتر مربوط به حالت عمومی بود، فروشگاه در نظر گرفته نشود
                if (startParam !== 'start' && startParam !== 'main' && startParam !== 'welcome') {
                    const parts = startParam.split('_');
                    const sIdx = parts.indexOf('s');
                    const cIdx = parts.indexOf('c');
                    if (sIdx !== -1) shop = parts[sIdx + 1];
                    if (cIdx !== -1) product = parts[cIdx + 1];
                }
            }

            // ورود به فروشگاه در صورت وجود پارامتر
            if (shop) {
                const targetUrl = product ? `/?sId=${shop}&pId=${product}` : `/?sId=${shop}`;
                navigate(targetUrl, { replace: true });
                return;
            }

            // اگر نام کاربری اینستاگرام پاس داده شده بود (و استارت یا روت نبود)
            if (param && !isRoot) {
                setStatus('loading');
                api.post('business/find/byInstagramUserName', { instagram_username: param })
                    .then((response) => {
                        if (response.data && response.data.success) {
                            navigate(`/?sId=${response.data.data}`, { replace: true });
                        } else {
                            setStatus('error');
                            setErrorMessage(response.data?.message || 'فروشگاه یافت نشد!');
                        }
                    })
                    .catch(() => {
                        setStatus('error');
                        setErrorMessage('خطا در ارتباط با سرور');
                    });
                return;
            }

            if (isRoot) {
                navigate('/HomePage', { replace: true });
                return;
            }
        }

        // =================================================================
        // حالت ۲: کاربر در مرورگر وب است (هدایت به بات تلگرام)
        // =================================================================
        const handleRedirectToBot = (targetUrl) => {
            setTargetTelegramUrl(targetUrl);
            setStatus('redirecting');
            try {
                window.location.href = targetUrl;
            } catch (e) {
                console.error("Redirect failed:", e);
            }
        };

        // اولویت اول: اگر کاربر آدرس /start را باز کرده است
        if (isStart) {
            handleRedirectToBot(`https://t.me/sabad1_shop_bot?startapp=main`);
            return;
        }

        // اولویت‌های بعدی: فروشگاه و محصول
        if (shop && product) {
            handleRedirectToBot(`https://t.me/sabad1_shop_bot?startapp=s_${shop}_c_${product}`);
            return;
        }

        if (shop) {
            handleRedirectToBot(`https://t.me/sabad1_shop_bot?startapp=s_${shop}`);
            return;
        }

        if (param && !isRoot) {
            setStatus('loading');
            api.post('business/find/byInstagramUserName', { instagram_username: param })
                .then((response) => {
                    if (response.data && response.data.success) {
                        handleRedirectToBot(`https://t.me/sabad1_shop_bot?startapp=s_${response.data.data}`);
                    } else {
                        setStatus('error');
                        setErrorMessage(response.data?.message || 'فروشگاه یافت نشد!');
                    }
                })
                .catch(() => {
                    setStatus('error');
                    setErrorMessage('خطا در ارتباط با سرور');
                });
            return;
        }

        if (isRoot) {
            handleRedirectToBot(`https://t.me/sabad1_shop_bot?startapp=welcome`);
            return;
        }

        setStatus('error');
        setErrorMessage('اطلاعات ورود نامعتبر است.');

    }, [param, shop, product, ChatId, navigate]);

    return (
        <div className="shop-loading">
            <img src="/images/rabet24.png" alt="background" className="bg-image" />

            <div className="shop-loading__overlay">
                {status === 'loading' && (
                    <div className="shimmer-wrapper">
                        <div className="shimmer-line"></div>
                        <p className="shimmer-text">در حال پردازش و ورود به برنامه...</p>
                    </div>
                )}

                {status === 'redirecting' && (
                    <div className="error-card" style={{ borderColor: '#229ED9' }}>
                        <div className="error-icon">🚀</div>
                        <p className="error-text" style={{ color: '#0f172a' }}>
                            در حال هدایت به مینی‌اپ تلگرام...
                        </p>
                        {targetTelegramUrl && (
                            <a
                                href={targetTelegramUrl}
                                className="retry-btn"
                                style={{
                                    display: 'inline-block',
                                    textDecoration: 'none',
                                    backgroundColor: '#229ED9',
                                    marginTop: '8px'
                                }}
                            >
                                ورود به تلگرام (کلیک کنید)
                            </a>
                        )}
                    </div>
                )}

                {status === 'error' && (
                    <div className="error-card">
                        <div className="error-icon">⚠️</div>
                        <p className="error-text">{errorMessage}</p>
                        <button
                            className="retry-btn"
                            onClick={() => window.location.href = '/'}
                        >
                            برگشت به صفحه اصلی
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ShopLoading;
